import { render, staticRenderFns } from "./delete-mapl.vue?vue&type=template&id=2650c231&scoped=true"
import script from "./delete-mapl.vue?vue&type=script&lang=js"
export * from "./delete-mapl.vue?vue&type=script&lang=js"
import style0 from "./delete-mapl.vue?vue&type=style&index=0&id=2650c231&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2650c231",
  null
  
)

export default component.exports